import React, { FC } from 'react';

import { Datepicker } from '../Inputs/datepicker';
import { Location } from '../Inputs/location';
import { Text } from '../Inputs/text';
import { Timepicker } from '../Inputs/timepicker';

import { breakupTranslation, IAbstractType } from '.';

import { useTranslation } from '#root/hooks/use-translation';
import { Keys } from '#root/translations-keys';

export const Wedding: FC<IAbstractType> = ({ control }) => {
  const t = useTranslation();
  const [title, body] = t(Keys.wizard.template.wedding).split('|');
  const parts = breakupTranslation(body);

  return (
    <>
      <h2>{title}</h2>
      <span>{parts.date}</span>
      <Datepicker control={control} />
      <span>{parts.clock}</span>
      <Timepicker control={control} />
      <span>{parts.churchLocation}</span>
      <Location name="churchLocation" required control={control} />
      <span>{parts.location}</span>
      <Location name="location" control={control} />
      <span>{parts.nameOnSpouse}</span>
      <Text name="nameOnSpouse" required control={control} />
      <span>{parts.name}</span>
      <Text name="name" required control={control} />
    </>
  );
};
